export const ABOUT = 'ABOUT';
export const GETTING_STARTED = 'GETTING_STARTED';
export const CONTACT = 'CONTACT';
export const HELP = 'HELP';
